var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.704 3.20779C11.0945 2.81735 11.0945 2.18327 10.704 1.79283C10.3136 1.40239 9.67952 1.40239 9.28908 1.79283L6 5.08504L2.70779 1.79595C2.31735 1.40551 1.68327 1.40551 1.29283 1.79595C0.90239 2.1864 0.90239 2.82047 1.29283 3.21092L4.58504 6.5L1.29595 9.79221C0.905513 10.1826 0.905513 10.8167 1.29595 11.2072C1.6864 11.5976 2.32047 11.5976 2.71092 11.2072L6 7.91496L9.29221 11.204C9.68265 11.5945 10.3167 11.5945 10.7072 11.204C11.0976 10.8136 11.0976 10.1795 10.7072 9.78908L7.41496 6.5L10.704 3.20779Z",
    fill: "#384665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9d7cdfcfd1cac39d218c60ed9a59d0ff.svg";
export { ForwardRef as ReactComponent };